<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="140px">
          <el-form-item label="天数:">
            <el-input-number v-model="queryParam.searchDay" ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="danger" size="medium" class="operator-btn3" style="width: 120px;" icon="el-icon-guide" @click="handleAddTask()">添加任务表</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="540"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @row-click="rowClick"
                @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="userPhone" label="手机号" width="180"></el-table-column>
        <el-table-column prop="name" label="会员姓名"></el-table-column>
        <!--<el-table-column prop="childGender" label="孩子性别"></el-table-column>-->
        <el-table-column prop="petName" label="小名"></el-table-column>
        <el-table-column prop="lastSingInTime" label="最近签到时间"></el-table-column>

        <!--<el-table-column prop="childType" label="类型"></el-table-column>-->
        <el-table-column prop="birthday" label="孩子生日"></el-table-column>
        <el-table-column prop="childMonth" label="孩子月龄"></el-table-column>
        <el-table-column prop="areaAddress" label="社区详细地址"></el-table-column>
        <el-table-column prop="taskFollowNote" label="任务备注"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>

  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {ECardUseType, EChildGender, EUserBuyCardStatu, getEnumDesByV} from "../../../utils/enumsUtil";
  import enumsUtil from "../../../utils/enumsUtil";
  import messageUtils from "../../../utils/messageUtils";
  import {queryBdChildNoSingIn, queryBdVIPWillInvalied} from "../../../api/bd/BaseData";
  import timeUtils from "../../../utils/timeUtils";

  export default {
    components: {},
    data() {
      return {
        listLoading: true,
        queryParam:{
          searchDay:7,
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        //表单结果
        tableData: [
        ],
        selectRow:null,
      }
    },
    created(){
      this.flechList();
    },
    mounted() {
    },
    methods: {

      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdBS(),
          day: this.queryParam.searchDay,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        const loading = this.myLoading("正在查询，请稍后！！！");
        queryBdChildNoSingIn(param).then(response =>
        {
          loading.close();
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
       this.tableData = list;
        for (let i = 0;i<  this.tableData.length;++i){
          let item =  this.tableData[i];
          this.tableData[i].genderDes =  EChildGender(item.gender);

          this.tableData[i].childType = enumsUtil.childBodyType(list[i].childType);
          let lastSingInTime = "无";
          if (!commonUtils.isObjectNull(item.lastSingInTime)){
            lastSingInTime = item.lastSingInTime;
          }
          this.tableData[i].lastSingInTime = lastSingInTime;

        }

      },

      rowClick(row, column, event){
        this.selectRow = row;
      },
      handleCheckSelect(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        return true;
      },


      onBtnCreate(){
        this.visibleDlgAdd = false;
        this.flechList();
      },
      onBtnCancel(){
        this.visibleDlgAdd = false;
      },
      onBtnOKBuyCard(){
        this.showAddCardDlg = false;
        this.refreshCard = new Date().getTime()

      },
      handleUpdateChild(){
        this.visibleDlgUpdateChildInfo = false;
        this.selectRow = null;
        this.flechList();
      },
      onBtnCancelUpdate(){
        this.visibleDlgUpdateChildInfo = false;
      },


      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleBookLesson(){
        if (!this.handleCheckSelect()){
          return;
        }
        this.addRefresh = new Date().getTime();
        this.visibleDlgBook = true;
      },


      handleCreateOne(){
        this.addRefresh = new Date().getTime()
        this.visibleDlgAdd = true;
      },
      handleByLesson(){
        this.showAddCardDlg = true;
        this.refreshCard = new Date().getTime()

      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList()
      },
      onBookSuccess(){
        this.visibleDlgBook = false;
      },

      onUpdateChildInfoShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.updateChildId  = this.selectRow.id

        this.visibleDlgUpdateChildInfo = true;

        this.updateRefresh = new Date().getTime();

      },

      /**
       * 添加线索
       */
      handleAddClueDig(){
        if (!this.handleCheckSelect()){
          return;
        }

        this.clueInfo = {
          childId :this.selectRow.id,
          userId :this.selectRow.userId,
          childName:this.selectRow.childName,
          childPetName:this.selectRow.childPetName,
          userPhone:this.selectRow.phoneNumber,
        }
        this.visibleDlgAddClue = true;

      },

      onCreateClueSuccess(){
        this.visibleDlgAddClue = false;
      },

      handleBuy(){
        this.visibleDlgBuyExpCard = false;
        this.flechList();
      },

      onBuyExpCardShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.buyExpCardChild = {
          name :this.selectRow.childName,
          userPhone:this.selectRow.phoneNumber,
          userId:this.selectRow.userId,
        }

        this.visibleDlgBuyExpCard = true;
        this.refreshBuyExpCard = new Date().getTime();

      },

      onChnageExpCardShow(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.changeExpCardChild = {
          name :this.selectRow.childName,
          userPhone:this.selectRow.phoneNumber,
          userId:this.selectRow.userId,
        }

        this.visibleDlgChangeExpCard = true;
        this.refreshChangeExpCard = new Date().getTime();

      },

      handleChange(){
        this.visibleDlgChangeExpCard = false;
        this.flechList();
      },
      handleAddTask(){
        let data = {
          taskType: 1,
          pList:[],
        }
        let pList = data.pList;
        for (let i = 0;i<this.multipleSelection.length;++i){
          pList.push({childName:this.multipleSelection[i].name,userId:this.multipleSelection[i].userId,phoneNumber:this.multipleSelection[i].userPhone})
        }
        this.$router.push({path: '/myStore/AddWorkerTask',query:data})

      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/base-data/bd-child-no-singin/indexBs.vue